module.exports = __webpack_public_path__ + "static/media/transfer_icon.87f83a91.svg";